module.exports = __webpack_public_path__ + "img/blueprint.73fe4053.png";